/* =========================================================================
   Aunty Cherish — Install Kit gifts (v2: customer picks 2 of 4)
   Free gifts are $0-priced products, so they're free with NO discount and
   stack cleanly with Mix & Save. Customer picks any 2 of 4 (incl. 2 of the
   same, or fewer) via an inline picker; default = Bonnet + Durag so the
   promise never breaks if they ignore it.

   Config (layout/theme.liquid): window.AC_GIFT = {
     threshold: <cents>, property: '_install_kit_gift', maxUnits: 2,
     defaults: [<variantId>, ...], optionIds: [<variantId>, ...]
   }
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.AC_GIFT || {};
  var THRESHOLD = parseInt(CFG.threshold, 10) || 9000;
  var FLAG = CFG.property || '_install_kit_gift';
  var MAX = parseInt(CFG.maxUnits, 10) || 2;
  var DEFAULTS = (CFG.defaults || []).map(Number).filter(Boolean);
  var OPTION_IDS = (CFG.optionIds || []).map(Number).filter(Boolean);
  var TOUCHED = '_gift_touched';

  if (!DEFAULTS.length || !OPTION_IDS.length) return;

  var busy = false;
  var debounceTimer = null;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Gift line items currently in the cart.
  function giftLines(cart) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var p = it.properties;
      if (p && (p[FLAG] === 'true' || p[FLAG] === true)) {
        out.push({ id: it.variant_id, key: it.key, qty: it.quantity });
      }
    }
    return out;
  }
  function totalUnits(lines) { return lines.reduce(function (s, l) { return s + l.qty; }, 0); }
  function isTouched(cart) { return cart.attributes && (cart.attributes[TOUCHED] === 'true' || cart.attributes[TOUCHED] === true); }

  function addUnits(id, qty) {
    var o = { id: id, quantity: qty, properties: {} };
    o.properties[FLAG] = 'true';
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [o] })
    });
  }
  function setQtyByKey(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  function setTouched(val) {
    var attrs = {}; attrs[TOUCHED] = val ? 'true' : '';
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function renderCart() {
    var ajaxForm = document.getElementById('AjaxCartForm');
    if (!ajaxForm) return Promise.resolve();
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newForm = doc.getElementById('AjaxCartForm');
        var newSub = doc.getElementById('AjaxCartSubtotal');
        if (newForm) {
          ajaxForm.innerHTML = newForm.innerHTML;
          if (typeof ajaxForm.ajaxifyCartItems === 'function') ajaxForm.ajaxifyCartItems();
        }
        var sub = document.getElementById('AjaxCartSubtotal');
        if (sub && newSub) sub.innerHTML = newSub.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        var total = doc.querySelector('[data-cart-total]');
        if (count) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = count.textContent; });
        if (total) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = total.textContent; });
      });
  }

  // Keep the cart valid: gifts only at/above threshold; default pair on a
  // fresh qualifying cart; never more than MAX units; respect the customer's
  // picks once they've touched the picker.
  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart()
      .then(function (cart) {
        var spend = cart.total_price; // gifts are $0, so this is real spend
        var lines = giftLines(cart);
        var units = totalUnits(lines);

        if (spend < THRESHOLD) {
          if (!lines.length) { if (isTouched(cart)) return setTouched(false); return; }
          return removeAll(lines).then(function () { return setTouched(false); }).then(renderCart);
        }

        // At/above threshold.
        if (units === 0 && !isTouched(cart)) {
          return addUnits(DEFAULTS[0], 1)
            .then(function () { return DEFAULTS[1] ? addUnits(DEFAULTS[1], 1) : null; })
            .then(renderCart);
        }
        if (units > MAX) { // safety trim
          return trimTo(lines, MAX).then(renderCart);
        }
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function removeAll(lines) {
    return lines.reduce(function (chain, l) { return chain.then(function () { return setQtyByKey(l.key, 0); }); }, Promise.resolve());
  }
  function trimTo(lines, max) {
    var over = totalUnits(lines) - max;
    var ops = [];
    for (var i = lines.length - 1; i >= 0 && over > 0; i--) {
      var take = Math.min(lines[i].qty, over);
      ops.push({ key: lines[i].key, qty: lines[i].qty - take });
      over -= take;
    }
    return ops.reduce(function (chain, o) { return chain.then(function () { return setQtyByKey(o.key, o.qty); }); }, Promise.resolve());
  }

  // Picker API — called by the inline +/- buttons in the cart.
  window.acGiftAdjust = function (variantId, delta) {
    variantId = Number(variantId);
    if (OPTION_IDS.indexOf(variantId) === -1) return;
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      if (cart.total_price < THRESHOLD) { busy = false; return; }
      var lines = giftLines(cart);
      var units = totalUnits(lines);
      var mine = lines.filter(function (l) { return l.id === variantId; })[0];
      var op;
      if (delta > 0) {
        if (units >= MAX) { busy = false; return; }
        op = mine ? setQtyByKey(mine.key, mine.qty + 1) : addUnits(variantId, 1);
      } else {
        if (!mine) { busy = false; return; }
        op = setQtyByKey(mine.key, mine.qty - 1);
      }
      return op.then(function () { return setTouched(true); }).then(function () { busy = false; return renderCart(); });
    }).catch(function () { busy = false; });
  };

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 220);
  }

  document.addEventListener('add-to-cart', schedule, true);
  document.addEventListener('cart-updated', schedule, true);

  // Delegated handler for the picker +/- buttons (survives cart re-renders).
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-ac-gift-plus]');
    var minus = e.target.closest && e.target.closest('[data-ac-gift-minus]');
    if (plus) { e.preventDefault(); window.acGiftAdjust(plus.getAttribute('data-ac-gift-plus'), 1); }
    else if (minus) { e.preventDefault(); window.acGiftAdjust(minus.getAttribute('data-ac-gift-minus'), -1); }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
